"use client"

import { CircleUserRound } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleUserRoundIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleUserRoundIcon = component(Icon)({ as: CircleUserRound })
